module.exports = {"410425001":"龙山街道","410425002":"东城街道","410425101":"冢头镇","410425102":"安良镇","410425103":"堂街镇","410425104":"薛店镇","410425105":"长桥镇","410425106":"茨芭镇","410425107":"黄道镇","410425108":"李口镇","410425200":"王集乡","410425202":"姚庄回族乡","410425203":"白庙乡","410425204":"广阔天地乡","410425205":"渣元乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410425.json
// module id = 1433
// module chunks = 0